export const EDIT_GG_POINT_OF_CONTACT_MODAL_NAME =
  'EDIT_GG_POINT_OF_CONTACT_MODAL_NAME';
